// THE THREE KINDS, as the screens name them. The kinds themselves are declared
// once, in @common/schema/site/blog, and this is only their wording and the
// element type each one renders — pure, so the Templates list, the editor,
// the element screens' links and the tests all agree on it.
import { TEMPLATE_KINDS } from "@common/schema/site/blog";
import * as Blog from "@common/render/blog";

export { TEMPLATE_KINDS };

export const TEMPLATE_LABELS = {
  post: "Post",
  list: "List",
  collection: "Collection",
};

// What each one is FOR, in the words the list shows beside its name.
export const TEMPLATE_DESCRIPTIONS = {
  post: "One post, on the page whose route names it — the title, the date, the author and the content.",
  list: "The listing: the published posts a page at a time, newest first, with links to the neighbouring pages.",
  collection: "A collection: its title and description, and its members in the order they were put in.",
};

// The element type a kind renders, which is what the editor's preview composes
// one of. Inverted from the renderer's own map so the two cannot disagree.
export const TEMPLATE_TYPES = Object.keys(Blog.KIND_OF).reduce((out, type) => {
  out[Blog.KIND_OF[type]] = type;
  return out;
}, {});

export const isKind = (kind) => TEMPLATE_KINDS.includes(kind);
